<template>
  <BaseAthleteCard
    :id="id"
    :name="name"
    :avatar="avatar"
    :is-selected="isSelected"
  >
    <template slot="caption">
      <div class="md-caption">
        <template v-if="team">
          <BaseAvatar
            :url="team.image_url"
            :size="20"
          />
          {{ team.name[$i18n.locale] }}
        </template>
        <div v-if="score">
          {{ $t('total-goals') }}: {{ score }}
        </div>
      </div>
    </template>

    <template
      v-if="time"
      slot="right"
    >
      <b-row>
        <b-col
          v-if="gif"
          class="d-flex align-items-center pr-0"
        >
          <PlayIcon @click="isGifModalOpen = true" />
          <TheAthletePerformanceGif
            v-if="gif && isGifModalOpen"
            :gif="gif"
            :athlete-name="name[$i18n.locale]"
            :athlete-avatar="avatar"
            :category-text="$tc(`athlete.performance.${category}`, value)"
            :time="$t('x-minute-of-match', { minute: time })"
            :team-name="team.name[$i18n.locale]"
            :team-image="team.image_url"
            @close="isGifModalOpen = false"
          />
        </b-col>
        <b-col
          class="d-flex justify-content-center text-nowrap flex-column text-center pl-1"
        >
          <div :class="$style.categoryTextWrapper">
            <span :class="$style.minuteText">{{ $t('x-minute-of-match', { minute: time }) }}</span>
            <span :class="$style.categoryText">
              {{ $tc(`athlete.performance.${category}`, value) }}
            </span>
          </div>
        </b-col>
      </b-row>
    </template>
  </BaseAthleteCard>
</template>

<script>
import BaseAvatar from '@/components/Atoms/BaseAvatar'
import BaseAthleteCard from '@/components/Atoms/BaseAthleteCard'
import PlayIcon from '@/components/Atoms/Icons/PlayIcon'
import TheAthletePerformanceGif from '@/components/Molecules/Modals/TheAthletePerformanceGif'

export default {
  name: 'TheAthleteGoalsOverviewCard',
  components: { TheAthletePerformanceGif, PlayIcon, BaseAthleteCard, BaseAvatar },
  inheritAttrs: false,
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: Object,
      required: true,
    },
    score: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    team: {
      type: Object,
      required: false,
      default: () => {},
    },
    category: {
      type: String,
      required: false,
      default: '',
    },
    value: {
      type: [Number, String],
      required: false,
      default: '',
    },
    time: {
      type: Number,
      required: false,
      default: null,
    },
    avatar: {
      type: String,
      required: false,
      default: null,
    },
    isSelected: {
      type: Boolean,
      required: false,
      default: false,
    },
    gif: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      isGifModalOpen: false,
    }
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";
  .minuteText {
    font-size: $font-size-small;
  }
  .categoryTextWrapper {
    min-width: 75px;
    display: flex;
    flex-direction: column;
    .categoryText {
      font-size: $font-size-tiny;
    }
  }
</style>
